import React, { useEffect, useState, useCallback } from "react";
import { chosenOptionType } from "../ChosenOption";
import api from "../../service/api";
import { AnimationData } from "../../assets/glb/animations";
import { OptionButtonMenu } from "../OptionButtonMenu";
import { LibrasButtonMenu } from "../LibrasButtonMenu";
import {
  getAnimationByTokens,
  handleAnimationOrder
} from "../../utils/animationHandle";
import { Container, Content } from "./styles";
import LibrasIcon from "../../assets/icons/libras-icon.svg";

type Question = {
  id: number;
  description: string;
  glosa: string;
  options: Option[];
  animations: AnimationData[];
};

type Scenario = {
  id: number;
  name: string;
  icon: string;
  glosa: string;
};

type Option = {
  id: number;
  description: string;
  glosa: string;
  animations: AnimationData[];
};

type Dictionary = { [index: string]: string };
const buttonMap: Dictionary = {
  FINISH_SESSION: "Finalizar sessão",
  GO_TO_START: "Ir para o início",
  GOT_TO_START: "Ir para o início",
  SUGGEST_SCENARIO: "Sugerir cenário"
};

interface InitialChatProps {
  animation: AnimationData[];
  scenarioId: number;
  onBack: any;
  setAnimation: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  setRepeat: React.Dispatch<React.SetStateAction<boolean>>;
  setHeaderAnimation: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  setStartChat: React.Dispatch<
    React.SetStateAction<{
      active: boolean;
      chosenOptionName?: string;
      chosenOptionIndex?: number;
    }>
  >;
  setScenarioName: React.Dispatch<React.SetStateAction<string | undefined>>; 
}

export function InitialChat({
  animation,
  setAnimation,
  setRepeat,
  setHeaderAnimation,
  setStartChat,
  setScenarioName
}: InitialChatProps) {
  const [chosenOption, setChosenOption] = useState<chosenOptionType>();
  const [scenarios, setScenarios] = useState<Scenario[]>([]);
  const [macroAnimations, setMacroAnimations] = useState<AnimationData[]>([]);
  const [allCurrentAnimations, setAllCurrentAnimations] = useState<
    AnimationData[]
  >([]);
  const [optionsInQuestion, setOptionsInQuestion] = useState<Option[]>([]);
  const [sessionId, setSessionId] = useState<string>("");

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filteredScenarios, setFilteredScenarios] = useState<Scenario[]>([]);
  const [filteredOptions, setFilteredOptions] = useState<Option[]>([]);

    const [loadingLibrasId, setLoadingLibrasId] = useState<number | null>(null);

  
  async function getQuestionById(id: number) {
    const request: Question = await api
      .get(`/question/option/${id}`, {
        headers: {
          "Session-Id": sessionId
        },
        withCredentials: true,
      })
      .then((res) => res.data)
      .then((data) => {
        setOptionsInQuestion(data.options);
        setAllCurrentAnimations(data.animations);
        if (data.options.length > 1) {
          setHeaderAnimation(data.animations);
        }
        return data;
      });

    return request;
  }

  function questionOptionsClick(option: Option, index: number) {
    switch (option.description) {
      case "GO_TO_START":
        setOptionsInQuestion([]);
        break;
      case "SUGGEST_SCENARIO":
        getAnimationByTokens("VOCE PODE ENVIAR DIGITAR OU FILMAR LIVRE ESCOLHER");
        break;
      case "FINISH_SESSION":
        getAnimationByTokens("INFORMACOES FIM");
        break;
      default:
        getQuestionById(option.id).then((request) => {
          const newAnimations = handleAnimationOrder(
            request.glosa,
            request.animations
          );
          setChosenOption(option.description as unknown as chosenOptionType);
          setAnimation(newAnimations);
         
          setStartChat({
            active: true,
            chosenOptionName: option.description,
            chosenOptionIndex: index
          });
        });
        break;
    }
  }

  function scenarioOptionsClick(scenario: Scenario, index: number) {
  

  setChosenOption(scenario.name as unknown as chosenOptionType);
  setAnimation(
    macroAnimations.filter((macro) => macro.glosa === scenario.glosa)
  );

  setScenarioName(scenario.name);

  
  setStartChat({
    active: true,
    chosenOptionName: scenario.name,
    chosenOptionIndex: index 
  });
}
  useEffect(() => {
    const scenarios = localStorage.getItem("scenarios");
    if (scenarios) setScenarios(JSON.parse(scenarios));

    const macroAnimations = localStorage.getItem("macroAnimations");
    if (macroAnimations) setMacroAnimations(JSON.parse(macroAnimations));
  }, []);
  
  useEffect(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) {
      setFilteredScenarios(scenarios);
      setFilteredOptions(optionsInQuestion);
      return;
    }

    setFilteredScenarios(
      scenarios.filter((s) => {
        const name = s.name?.toLowerCase() ?? "";
        const glosa = s.glosa?.toLowerCase() ?? "";
        return name.includes(term) || glosa.includes(term);
      })
    );

    setFilteredOptions(
      optionsInQuestion.filter((o) => {
        const label = (buttonMap[o.description] ?? o.description).toLowerCase();
        const glosa = o.glosa?.toLowerCase() ?? "";
        return label.includes(term) || glosa.includes(term);
      })
    );
  }, [searchTerm, scenarios, optionsInQuestion]);

  const handleLibrasSelection = useCallback((detectedNumber: string) => {
    const index = parseInt(detectedNumber, 10);
    if (isNaN(index)) return;

    const indexTarget = index - 1;

    if (filteredScenarios[indexTarget]) {
      scenarioOptionsClick(filteredScenarios[indexTarget], filteredScenarios[indexTarget].id);
    } 
    else {
      const optionIndex = indexTarget - filteredScenarios.length;
      if (filteredOptions[optionIndex]) {
        questionOptionsClick(filteredOptions[optionIndex], optionIndex + 1);
      }
    }
  }, [filteredScenarios, filteredOptions]);

  useEffect(() => {
    const onLibrasEvent = (event: any) => {
      const num = event.detail.number;
      handleLibrasSelection(num);
    };

    window.addEventListener("LIBRAS_SELECTION", onLibrasEvent);

    return () => {
      window.removeEventListener("LIBRAS_SELECTION", onLibrasEvent);
    };
  }, [handleLibrasSelection]);

  return (
    <Container>
      <Content id="content">
          <div className="ScenarioSearch">
          <form
            className="SearchForm"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <span className="material-icons-outlined Icon">search</span>
            <input
              type="text"
              id="myInput"
              className="input"
              placeholder="Buscar"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {searchTerm && (
              <span
                className="material-icons-outlined"
                onClick={() => setSearchTerm("")}
              >
                close
              </span>
            )}
        </form>
        </div>
        <div className="menuOption">
          {filteredScenarios.map((scenario, index) => (
            <div className="menuLibras" key={scenario.id}>
              <OptionButtonMenu
                onClick={() => {
                  scenarioOptionsClick(scenario, scenario.id);
                }}
              >
                {`${index + 1}) ${scenario.name}`}
              </OptionButtonMenu>
              <LibrasButtonMenu
                disabled={loadingLibrasId === scenario.id}
                onClick={async (e) => {
                  e.stopPropagation();

                  try {
                    setLoadingLibrasId(scenario.id); // liga loading nesse botão
                    window.dispatchEvent(new CustomEvent("LISA_INTERRUPT"));


                    const animations = await getAnimationByTokens(scenario.glosa);
                    console.log("ANIMAÇÕES ENCONTRADAS:", animations);
                    setAnimation(animations);

                    window.dispatchEvent(new CustomEvent("LISA_RESUME"));
                  } finally {
                    setLoadingLibrasId(null); // desliga loading
                  }
                }}
              >
                {loadingLibrasId === scenario.id ? (
                  <span className="btnSpinner" aria-label="Carregando" />
                ) : (
                  <img src={LibrasIcon} alt="Ícone Libras" />
                )}
              </LibrasButtonMenu>

            </div>
          ))}
        </div>

        <div className="menuOption">
          {filteredOptions.map((option, index) => (
            <div className="menuLibras" key={option.id}>
              <OptionButtonMenu
                onClick={() => questionOptionsClick(option, index + 1)}
              >
                {buttonMap[option.description] ?? option.description}
              </OptionButtonMenu>
            </div>
          ))}
        </div>
      </Content>
    </Container>
  );
}
